import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownMenu, ButtonDropdown, DropdownItem, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';
import stickybits from 'stickybits';
import ShopFilterSearchTextbox from '../components/ShopFilterSearchTextbox.js';
import ShopCurrentFilters from '../components/ShopCurrentFilters.js';
import ShopProductListing from '../components/ShopProductListing.js';
import ShopDropdownSort from '../components/ShopDropdownSort.js';

export default class ShopContentUnder768 extends Component {
  static propTypes = {
    setSearchValue: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    hasMoreToScroll: PropTypes.bool.isRequired,
    loadMoreScroll: PropTypes.func.isRequired,
    windowWidth: PropTypes.number.isRequired,
    toggleFilter: PropTypes.func.isRequired,
    products: PropTypes.array.isRequired,
    usableProducts: PropTypes.array.isRequired,
    visibleProducts: PropTypes.array.isRequired,
    productTypeInfo_DictionaryArray: PropTypes.array.isRequired,
    togglePureMaple: PropTypes.func.isRequired,
    toggleExtraValue: PropTypes.func.isRequired,
    toggleNonMaple: PropTypes.func.isRequired,
    pureMapleCheck: PropTypes.func.isRequired,
    extraValueCheck: PropTypes.func.isRequired,
    nonMapleCheck: PropTypes.func.isRequired,
    pureSyrupCheck: PropTypes.func.isRequired,
    pureCreamCheck: PropTypes.func.isRequired,
    pureCandyCheck: PropTypes.func.isRequired,
    pureSugarCheck: PropTypes.func.isRequired,
    extraSaucesCheck: PropTypes.func.isRequired,
    extraBeveragesCheck: PropTypes.func.isRequired,
    extraCandyCheck: PropTypes.func.isRequired,
    extraJellyCheck: PropTypes.func.isRequired,
    extraGiftSetsCheck: PropTypes.func.isRequired,
    nonPancakeMixesCheck: PropTypes.func.isRequired,
    nonInformationalCheck: PropTypes.func.isRequired,
    nonClothesCheck: PropTypes.func.isRequired,
    nonCandlesCheck: PropTypes.func.isRequired,
    nonKitchenwareCheck: PropTypes.func.isRequired,
    nonBooksCheck: PropTypes.func.isRequired,
    addItemToCart: PropTypes.func.isRequired,
    addItemToCartState: PropTypes.func.isRequired,
    cartItemCount: PropTypes.number.isRequired,
    dropdownSort: PropTypes.func.isRequired,
    selectDropdownItem: PropTypes.func.isRequired,
    toggleDropdownOpen: PropTypes.func.isRequired,
    dropdownOpen: PropTypes.bool.isRequired,
    dropdownValue: PropTypes.string.isRequired,
    scrollToTop: PropTypes.func.isRequired,
    showScrollUpButton: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  componentDidMount() {
    stickybits("#scrollToTopButtonID", {verticalPosition: "bottom"});
  }

  render() {
    const ShopContainer_Under768 = (
      <Container_Under768>
        <h1 style={{textAlign: "center", marginBottom: "25px"}}>Shop Patterson Farms</h1> 
        
        {/*<DivSpecial><p><b>FREE</b> bag of maple crunchies (a $9.50 value!) for every $25.00 spent! <i>Sale ends June 30th, 2020.</i></p></DivSpecial>*/}
        
        <ShopFilterSearchTextbox toggleFilter={this.props.toggleFilter} windowWidth={this.props.windowWidth}
          setSearchValue={this.props.setSearchValue} searchValue={this.props.searchValue} cartItemCount={this.props.cartItemCount} />

        <ShopCurrentFilters {...this.props} usableProductsCount={this.props.usableProducts.length} />

        <ShopDropdownSort selectDropdownItem={this.props.selectDropdownItem} toggleDropdownOpen={this.props.toggleDropdownOpen}
                          dropdownOpen={this.props.dropdownOpen} dropdownValue={this.props.dropdownValue} />

        <ShopProductListing products={this.props.products} usableProducts={this.props.usableProducts} visibleProducts={this.props.visibleProducts}
            hasMoreToScroll={this.props.hasMoreToScroll} loadMoreScroll={this.props.loadMoreScroll} 
            addItemToCart={this.props.addItemToCart} addItemToCartState={this.props.addItemToCartState} />

        {this.props.showScrollUpButton ?
          <ScrollToTopImage id="scrollToTopButtonID" onClick={this.props.scrollToTop} 
          src={require("../media/scrollUpArrow2.png")}></ScrollToTopImage>
        :
        "" }

      </Container_Under768>
    );

    return (
      <FluidContainer className="p-0" fluid>
          {ShopContainer_Under768}
      </FluidContainer>
    );
  }
}

const DivSpecial = styled.div``;

const ScrollToTopImage = styled.img`
  width: 50px; 
  height: 50px;
  background: transparent;
  color: white;
  bottom: 0;
  display: block!important;
  margin: 0 auto;
  padding: 0!important;
  cursor: pointer;
  position: sticky;
`;

const FluidContainer = styled(Container)`  `;
const InternalContainer = styled(Container)`  `;

const Container_Under768 = styled(Container)`  `;
  
/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopContentUnder768.js